import React from 'react'

interface Props {
  messages: string[]
}

export const Messages = ({ messages }: Props) =>
  <div style={{padding: 4, marginTop: 5, marginBottom: 5}} className='border-red small bold'>
    <div style={{verticalAlign: 'top', marginRight: 8}} className='inline-block emoji'>⚠</div>
    <div className='inline-block'>
      {messages.map(m => <div key={m}>{m}</div>)}
    </div>
  </div>
